module.exports = __webpack_public_path__ + "img/KinokoTable00.fdc55c0d.jpg";